import { DNSFormType } from "./first-step.types";

export const dnsFormInitialValues: DNSFormType = {
  domain: "",
  topLevelDomain: "",
};

export const DNS_FORM_ID = "dns-form";
